(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cornerstone-ingredients"] && !Shopify.designMode) return;
  try {
    
  class CornerstoneIngredients extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-item-tab]')];
      this.backgrounds = [...this.querySelectorAll('[data-item-background]')];
      this.panels = [...this.querySelectorAll('[data-item-panel]')];
      this.images = [...this.querySelectorAll('[data-item-image]')];
      this.desktopQuery = window.matchMedia('(min-width: 750px)');

      for (const tab of this.tabs) {
        tab.addEventListener('mouseenter', this.#handleHover);
        tab.addEventListener('focus', this.#handleFocus);
        tab.addEventListener('click', this.#handleClick);
      }

      const initialIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.#updateReverseLayout(initialIndex >= 0 ? initialIndex : 0);
    }

    disconnectedCallback() {
      for (const tab of this.tabs || []) {
        tab.removeEventListener('mouseenter', this.#handleHover);
        tab.removeEventListener('focus', this.#handleFocus);
        tab.removeEventListener('click', this.#handleClick);
      }
    }

    #handleHover = (event) => {
      if (!this.desktopQuery.matches) return;
      this.#activateByEvent(event);
    };

    #handleFocus = (event) => {
      this.#activateByEvent(event);
    };

    #handleClick = (event) => {
      this.#activateByEvent(event);
    };

    #activateByEvent(event) {
      if (!(event.currentTarget instanceof HTMLElement)) return;
      const index = Number(event.currentTarget.dataset.itemTab);
      if (!Number.isFinite(index)) return;
      this.#setActive(index);
    }

    #setActive(index) {
      for (const [itemIndex, tab] of this.tabs.entries()) {
        const selected = itemIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      }

      for (const [itemIndex, background] of this.backgrounds.entries()) {
        const selected = itemIndex === index;
        background.hidden = !selected;
        background.classList.toggle('is-active', selected);
      }

      for (const [itemIndex, panel] of this.panels.entries()) {
        const selected = itemIndex === index;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      }

      for (const [itemIndex, image] of this.images.entries()) {
        const selected = itemIndex === index;
        image.hidden = !selected;
        image.classList.toggle('is-active', selected);
      }

      this.#updateReverseLayout(index);
    }

    #updateReverseLayout(index) {
      const activePanel = this.panels[index];
      const activeImage = this.images[index];
      const isReverse = activePanel?.dataset.reverseLayout === 'true';

      this.classList.toggle('cornerstone-ingredients--reverse', isReverse);

      if (activeImage) {
        const desktopWidth = activeImage.style.getPropertyValue('--cornerstone-main-image-width-desktop').trim();
        if (desktopWidth) {
          this.style.setProperty('--cornerstone-active-main-image-width', desktopWidth);
        }
      }
    }
  }

  if (!customElements.get('cornerstone-ingredients')) {
    customElements.define('cornerstone-ingredients', CornerstoneIngredients);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /** @type {HTMLElement|null} */
    const header = document.querySelector('#maiwe-header.custom-header');
    if (!header) return;

    let ticking = false;

    const updateAtTop = () => {
      header.dataset.atTop = window.scrollY <= 0 ? 'true' : 'false';
    };

    const LIGHT_COLOR_SCHEMES = new Set(['scheme-1', 'scheme-2']);
    const MEDIA_SECTION_SELECTOR =
      '.hero-wrapper, .hero, .step-sequence-carousel, .cornerstone-ingredients, .product-showcase-carousel';

    /** Parse rgb/hex CSS colors for luminance checks. */
    const parseCssColor = (cssColor) => {
      const trimmed = cssColor.trim();
      if (!trimmed || trimmed === 'transparent') return null;

      const rgbMatch = trimmed.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)/);
      if (rgbMatch) {
        return {
          r: Number(rgbMatch[1]),
          g: Number(rgbMatch[2]),
          b: Number(rgbMatch[3]),
          a: rgbMatch[4] === undefined ? 1 : Number(rgbMatch[4]),
        };
      }

      const hexMatch = trimmed.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
      if (!hexMatch) return null;

      let hex = hexMatch[1];
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((char) => char + char)
          .join('');
      }

      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
        a: 1,
      };
    };

    /** WCAG relative luminance for an rgb object. */
    const relativeLuminance = (rgb) => {
      const channel = (value) => {
        const normalized = value / 255;
        return normalized <= 0.03928
          ? normalized / 12.92
          : ((normalized + 0.055) / 1.055) ** 2.4;
      };

      const r = channel(rgb.r);
      const g = channel(rgb.g);
      const b = channel(rgb.b);
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    const getSectionColorScheme = (section) => {
      const schemeNode = section.querySelector('[class*="color-scheme"], [class^="color-"]');
      if (!schemeNode) return null;

      for (const className of schemeNode.classList) {
        if (className.startsWith('color-') && className.length > 6) {
          return className.slice(6);
        }
      }

      return null;
    };

    /** Warm white chips on imagery/dark/tan bands; tan chips on white/light sections. */
    const sectionNeedsWarmChips = (section) => {
      if (section.querySelector(MEDIA_SECTION_SELECTOR)) return true;

      const scheme = getSectionColorScheme(section);
      if (scheme === 'scheme-6') return true;
      if (scheme === 'scheme-3') return true;
      if (scheme && LIGHT_COLOR_SCHEMES.has(scheme)) return false;

      const backgroundNode = section.querySelector('.section-background');
      if (backgroundNode) {
        const parsed = parseCssColor(getComputedStyle(backgroundNode).backgroundColor);
        if (parsed && parsed.a > 0.05) {
          return relativeLuminance(parsed) < 0.72;
        }
      }

      return false;
    };

    const getSectionUnderHeader = () => {
      const headerRect = header.getBoundingClientRect();
      const x = Math.min(window.innerWidth - 1, Math.max(1, window.innerWidth / 2));
      const y = Math.min(window.innerHeight - 1, Math.max(1, headerRect.bottom - 1));

      for (const element of document.elementsFromPoint(x, y)) {
        const section = element.closest('#MainContent > .shopify-section');
        if (section instanceof HTMLElement) return section;
      }

      return null;
    };

    const updateChipTone = () => {
      if (header.dataset.pageType !== 'index') {
        header.dataset.chipTone = 'tan';
        return;
      }

      const section = getSectionUnderHeader();
      header.dataset.chipTone = section && sectionNeedsWarmChips(section) ? 'warm' : 'tan';
    };

    const updateScrollState = () => {
      updateAtTop();
      updateChipTone();
      ticking = false;
    };

    updateScrollState();

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateScrollState);
      },
      { passive: true }
    );

    window.addEventListener('resize', updateChipTone, { passive: true });
  })();

  class MaiweHeaderMenu extends HTMLElement {
    /** @type {MediaQueryList} */
    #desktopLayoutQuery = window.matchMedia('(min-width: 992px)');

    /** @type {number | null} */
    #closeDelayTimer = null;

    /** @type {boolean} */
    #hoverBound = false;

    /** @type {boolean} */
    #pointerDownInsideSubmenu = false;

    connectedCallback() {
      this.#bind();
    }

    disconnectedCallback() {
      this.#clearCloseDelay();
      this.#unbindHover();
      this.#desktopLayoutQuery.removeEventListener('change', this.#handleLayoutChange);
      document.removeEventListener('click', this.#handleDocumentClick);
      document.removeEventListener('keydown', this.#handleKeydown);
    }

    #bind() {
      const triggers = Array.from(this.querySelectorAll('[data-submenu-trigger="top"]'));
      if (triggers.length === 0) return;

      this.#bindHover();
      this.#desktopLayoutQuery.addEventListener('change', this.#handleLayoutChange);

      document.addEventListener('click', this.#handleDocumentClick, { passive: true });
      document.addEventListener('keydown', this.#handleKeydown);
    }

    /**
     * @param {Element | null | undefined} element
     * @returns {element is HTMLElement}
     */
    #isSubmenuTrigger(element) {
      return element instanceof HTMLElement && element.matches('[data-submenu-trigger="top"]');
    }

    #bindHover() {
      if (this.#hoverBound || !this.#desktopLayoutQuery.matches) return;
      this.#hoverBound = true;

      for (const item of this.querySelectorAll('.maiwe-header-menu__item[data-submenu-id]')) {
        const trigger = item.querySelector('[data-submenu-trigger="top"]');
        const submenu = item.querySelector('.maiwe-header-menu__submenu');
        if (!this.#isSubmenuTrigger(trigger) || !(submenu instanceof HTMLElement)) continue;

        trigger.addEventListener('pointerenter', this.#handleTriggerEnter);
        submenu.addEventListener('pointerenter', this.#handleTriggerEnter);
        trigger.addEventListener('pointerleave', this.#handlePointerLeave);
        submenu.addEventListener('pointerleave', this.#handlePointerLeave);
        submenu.addEventListener('pointerdown', this.#handleSubmenuPointerDown);
        trigger.addEventListener('focusin', this.#handleTriggerFocusIn);
        item.addEventListener('focusout', this.#handleItemFocusOut);
      }
    }

    #unbindHover() {
      if (!this.#hoverBound) return;
      this.#hoverBound = false;

      for (const item of this.querySelectorAll('.maiwe-header-menu__item[data-submenu-id]')) {
        const trigger = item.querySelector('[data-submenu-trigger="top"]');
        const submenu = item.querySelector('.maiwe-header-menu__submenu');
        if (!this.#isSubmenuTrigger(trigger) || !(submenu instanceof HTMLElement)) continue;

        trigger.removeEventListener('pointerenter', this.#handleTriggerEnter);
        submenu.removeEventListener('pointerenter', this.#handleTriggerEnter);
        trigger.removeEventListener('pointerleave', this.#handlePointerLeave);
        submenu.removeEventListener('pointerleave', this.#handlePointerLeave);
        submenu.removeEventListener('pointerdown', this.#handleSubmenuPointerDown);
        trigger.removeEventListener('focusin', this.#handleTriggerFocusIn);
        item.removeEventListener('focusout', this.#handleItemFocusOut);
      }
    }

    #handleLayoutChange = (event) => {
      if (event.matches) {
        this.#bindHover();
        return;
      }

      this.#clearCloseDelay();
      this.#unbindHover();
      this.#closeAll();
    };

    #handleTriggerEnter = (event) => {
      if (!this.#desktopLayoutQuery.matches) return;

      const item = event.currentTarget?.closest('.maiwe-header-menu__item');
      const trigger = item?.querySelector('[data-submenu-trigger="top"]');
      if (!this.#isSubmenuTrigger(trigger) || !(item instanceof HTMLElement)) return;

      this.#clearCloseDelay();
      this.#openSubmenuForTrigger(trigger);
    };

    #handlePointerLeave = (event) => {
      if (!this.#desktopLayoutQuery.matches) return;
      if (this.#pointerDownInsideSubmenu) return;
      if (!(event.currentTarget instanceof HTMLElement)) return;

      const item = event.currentTarget.closest('.maiwe-header-menu__item');
      const related = event.relatedTarget;

      if (item instanceof HTMLElement && related instanceof Node && item.contains(related)) return;

      const trigger = item?.querySelector('[data-submenu-trigger="top"]');
      if (!this.#isSubmenuTrigger(trigger) || !(item instanceof HTMLElement)) return;

      this.#scheduleCloseForTrigger(trigger, item);
    };

    #handleSubmenuPointerDown = () => {
      if (!this.#desktopLayoutQuery.matches) return;
      this.#clearCloseDelay();
      this.#pointerDownInsideSubmenu = true;
      document.addEventListener('pointerup', this.#handleDocumentPointerUp, { once: true, capture: true });
      document.addEventListener('pointercancel', this.#handleDocumentPointerUp, { once: true, capture: true });
    };

    #handleDocumentPointerUp = () => {
      this.#pointerDownInsideSubmenu = false;
    };

    /**
     * Quiz step changes hide the clicked control; relatedTarget is often null on pointerleave.
     * Re-check hover/focus before closing so embedded interactions do not collapse the mega menu.
     * @param {HTMLElement | null | undefined} item
     * @param {HTMLElement} trigger
     * @param {HTMLElement | null | undefined} submenu
     * @returns {boolean}
     */
    #shouldKeepSubmenuOpen(item, trigger, submenu) {
      if (this.#pointerDownInsideSubmenu) return true;
      if (this.#isHoveringMenuItem(item, trigger, submenu)) return true;
      if (submenu instanceof HTMLElement && submenu.contains(document.activeElement)) return true;
      return false;
    }

    /**
     * @param {HTMLElement | null | undefined} item
     * @param {HTMLElement} trigger
     * @param {HTMLElement | null | undefined} submenu
     * @returns {boolean}
     */
    #isHoveringMenuItem(item, trigger, submenu) {
      return (
        (item instanceof HTMLElement && item.matches(':hover')) ||
        (trigger instanceof HTMLElement && trigger.matches(':hover')) ||
        (submenu instanceof HTMLElement && submenu.matches(':hover'))
      );
    }

    /**
     * @param {HTMLElement} trigger
     * @param {HTMLElement} item
     */
    #scheduleCloseForTrigger(trigger, item) {
      this.#clearCloseDelay();
      this.#closeDelayTimer = window.setTimeout(() => {
        window.requestAnimationFrame(() => {
          const submenu = item.querySelector('.maiwe-header-menu__submenu');
          if (this.#shouldKeepSubmenuOpen(item, trigger, submenu)) return;
          this.#closeTrigger(trigger);
        });
      }, 300);
    }

    #handleTriggerFocusIn = (event) => {
      if (!this.#desktopLayoutQuery.matches) return;
      if (!this.#isSubmenuTrigger(event.currentTarget)) return;

      this.#clearCloseDelay();
      this.#openSubmenuForTrigger(event.currentTarget);
    };

    #handleItemFocusOut = (event) => {
      if (!this.#desktopLayoutQuery.matches) return;
      if (!(event.currentTarget instanceof HTMLElement)) return;

      const item = event.currentTarget;
      const related = event.relatedTarget;

      if (related instanceof Node && item.contains(related)) return;

      const trigger = item.querySelector('[data-submenu-trigger="top"]');
      if (!this.#isSubmenuTrigger(trigger)) return;

      this.#scheduleCloseForTrigger(trigger, item);
    };

    #clearCloseDelay() {
      if (this.#closeDelayTimer == null) return;
      window.clearTimeout(this.#closeDelayTimer);
      this.#closeDelayTimer = null;
    }

    /**
     * @param {HTMLElement} trigger
     * @returns {boolean}
     */
    #openSubmenuForTrigger(trigger) {
      this.#clearCloseDelay();

      const controls = trigger.getAttribute('aria-controls');
      if (!controls) return false;

      const submenu = this.querySelector(`#${CSS.escape(controls)}`);
      if (!(submenu instanceof HTMLElement)) return false;

      const parentList = trigger.closest('ul');
      if (parentList) {
        this.#closeTriggersInContainer(parentList, trigger);
      }

      trigger.setAttribute('aria-expanded', 'true');
      submenu.hidden = false;
      return true;
    }

    /**
     * Opens a top-level mega menu by nav handle (`data-menu-key`, same as `link.title | handleize`).
     * Deep link: `#maiwe-menu-{handle}` e.g. `#maiwe-menu-skin-quiz`.
     * @param {string} menuKey
     * @returns {boolean}
     */
    openMenuByKey(menuKey) {
      const key = String(menuKey || '').trim();
      if (!key) return false;

      for (const item of this.querySelectorAll('li.maiwe-header-menu__item[data-menu-key]')) {
        if (!(item instanceof HTMLElement)) continue;
        if (item.dataset.menuKey !== key) continue;

        const trigger = item.querySelector('[data-submenu-trigger="top"]');
        if (!this.#isSubmenuTrigger(trigger)) return false;

        return this.#openSubmenuForTrigger(trigger);
      }

      return false;
    }

    #closeTrigger(trigger) {
      const controls = trigger.getAttribute('aria-controls');
      trigger.setAttribute('aria-expanded', 'false');

      if (!controls) return;

      /** @type {HTMLElement|null} */
      const submenu = this.querySelector(`#${CSS.escape(controls)}`);
      if (!submenu) return;
      submenu.hidden = true;
    }

    #closeTriggersInContainer(container, exceptTrigger) {
      const expanded = container.querySelectorAll('[data-submenu-trigger="top"][aria-expanded="true"]');
      for (const btn of expanded) {
        if (btn === exceptTrigger) continue;
        this.#closeTrigger(btn);
      }
    }

    #closeAll() {
      this.#clearCloseDelay();
      const expanded = this.querySelectorAll('[data-submenu-trigger="top"][aria-expanded="true"]');
      for (const btn of expanded) {
        this.#closeTrigger(btn);
      }
    }

    #handleDocumentClick = (event) => {
      if (!(event.target instanceof Node)) return;
      if (this.contains(event.target)) return;
      if (event.target instanceof Element && event.target.closest('[data-floating-promo-root]')) return;
      this.#closeAll();
    };

    #handleKeydown = (event) => {
      if (event.key !== 'Escape') return;
      this.#closeAll();
    };
  }

  if (!customElements.get('maiwe-header-menu')) {
    customElements.define('maiwe-header-menu', MaiweHeaderMenu);
  }

  class MaiweMobileMenu extends HTMLElement {
    /** @type {HTMLButtonElement | null} */
    #activeTrigger = null;

    /** @type {MediaQueryList} */
    #mobileLayoutQuery = window.matchMedia('(max-width: 991px)');

    connectedCallback() {
      this.#bind();
      this.#mobileLayoutQuery.addEventListener('change', this.#handleLayoutChange);
      if (!this.#mobileLayoutQuery.matches) {
        this.#closeImmediately();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.#handleKeydown);
      this.#mobileLayoutQuery.removeEventListener('change', this.#handleLayoutChange);
    }

    #bind() {
      const openButton = document.querySelector('[data-mobile-menu-open]');
      openButton?.addEventListener('click', () => {
        if (!(openButton instanceof HTMLButtonElement)) return;
        this.open(openButton);
      });

      const closeButtons = this.querySelectorAll('[data-mobile-menu-close]');
      for (const button of closeButtons) {
        button.addEventListener('click', () => this.close());
      }

      const submenuTriggers = this.querySelectorAll('[data-mobile-submenu-open]');
      for (const trigger of submenuTriggers) {
        trigger.addEventListener('click', () => {
          if (!(trigger instanceof HTMLButtonElement)) return;
          this.#openSubmenu(trigger);
        });
      }

      const submenuCloseButtons = this.querySelectorAll('[data-mobile-submenu-close]');
      for (const button of submenuCloseButtons) {
        button.addEventListener('click', () => this.#closeSubmenus());
      }

      const submenus = this.querySelectorAll('[data-mobile-submenu]');
      for (const submenu of submenus) {
        submenu.addEventListener('click', (event) => {
          const drawer = submenu.querySelector('.custom-header-mobile__submenu-drawer');
          if (drawer && !drawer.contains(event.target)) {
            this.#closeSubmenus();
          }
        });
      }

      const links = this.querySelectorAll('a');
      for (const link of links) {
        link.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', this.#handleKeydown);
    }

    open(trigger) {
      this.#activeTrigger = trigger;
      this.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.#focusFirstControl();
      });
    }

    close() {
      this.classList.remove('is-open');
      this.#closeSubmenus();
      this.#activeTrigger?.setAttribute('aria-expanded', 'false');
      this.#activeTrigger?.focus();
      window.setTimeout(() => {
        this.hidden = true;
        this.dispatchEvent(new CustomEvent('maiwe:menu-closed', { bubbles: true }));
      }, 250);
    }

    /**
     * Closes the drawer immediately (no transition delay). Used when leaving the mobile breakpoint.
     */
    #closeImmediately() {
      if (!this.classList.contains('is-open') && this.hidden) return;

      this.classList.remove('is-open');
      this.#closeSubmenus(true);
      this.#activeTrigger?.setAttribute('aria-expanded', 'false');
      this.#activeTrigger = null;
      this.hidden = true;
      this.dispatchEvent(new CustomEvent('maiwe:menu-closed', { bubbles: true }));
    }

    #handleLayoutChange = (event) => {
      if (event.matches) return;
      this.#closeImmediately();
    };

    #openSubmenu(trigger) {
      const controls = trigger.getAttribute('aria-controls');
      if (!controls) return;

      this.#closeSubmenus();

      const submenu = this.querySelector(`#${CSS.escape(controls)}`);
      if (!(submenu instanceof HTMLElement)) return;

      submenu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        submenu.classList.add('is-open');
        const closeButton = submenu.querySelector('[data-mobile-submenu-close]');
        if (closeButton instanceof HTMLButtonElement) {
          closeButton.focus();
        }
      });
    }

    /**
     * Opens the drawer + nested submenu for a top-level item (`data-menu-key`).
     * Deep link: `#maiwe-menu-{handle}` (must match desktop mega menu key).
     * @param {string} menuKey
     * @returns {boolean}
     */
    openMenuByKey(menuKey) {
      const key = String(menuKey || '').trim();
      if (!key) return false;

      /** @type {HTMLButtonElement | null} */
      let trigger = null;

      for (const btn of this.querySelectorAll('button[data-mobile-submenu-open][data-menu-key]')) {
        if (!(btn instanceof HTMLButtonElement)) continue;
        if (btn.dataset.menuKey === key) {
          trigger = btn;
          break;
        }
      }

      if (!trigger) return false;

      const openBtn = document.querySelector('[data-mobile-menu-open]');
      if (!(openBtn instanceof HTMLButtonElement)) return false;

      this.open(openBtn);
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => this.#openSubmenu(trigger));
      });
      return true;
    }

    #closeSubmenus(immediate = false) {
      const openSubmenus = this.querySelectorAll('[data-mobile-submenu].is-open');
      for (const submenu of openSubmenus) {
        submenu.classList.remove('is-open');
        if (immediate) {
          if (submenu instanceof HTMLElement) {
            submenu.hidden = true;
          }
          continue;
        }

        window.setTimeout(() => {
          if (submenu instanceof HTMLElement) {
            submenu.hidden = true;
          }
        }, 250);
      }

      const expandedTriggers = this.querySelectorAll('[data-mobile-submenu-open][aria-expanded="true"]');
      for (const trigger of expandedTriggers) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    #focusFirstControl() {
      const closeButton = this.querySelector('[data-mobile-menu-close]');
      if (closeButton instanceof HTMLButtonElement) {
        closeButton.focus();
      }
    }

    #handleKeydown = (event) => {
      if (event.key !== 'Escape') return;
      this.close();
    };
  }

  if (!customElements.get('maiwe-mobile-menu')) {
    customElements.define('maiwe-mobile-menu', MaiweMobileMenu);
  }

  (() => {
    const MENU_HASH_PREFIX = 'maiwe-menu-';

    /** @returns {string} */
    function menuKeyFromHash() {
      const raw = decodeURIComponent((window.location.hash || '').replace(/^#/, '').trim());
      if (!raw.startsWith(MENU_HASH_PREFIX)) return '';
      return raw.slice(MENU_HASH_PREFIX.length).trim();
    }

    function stripMenuDeepLinkHash() {
      const raw = decodeURIComponent((window.location.hash || '').replace(/^#/, '').trim());
      if (!raw.startsWith(MENU_HASH_PREFIX)) return;
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(window.history.state, '', cleanUrl);
    }

    /**
     * Opens a top-level header mega menu / mobile drawer panel by `data-menu-key`.
     * @param {string} menuKey
     * @param {{ scroll?: boolean }} [options]
     * @returns {boolean}
     */
    function maiweOpenMenuByKey(menuKey, options = {}) {
      const key = String(menuKey || '').trim();
      if (!key) return false;

      if (options.scroll !== false) {
        document.querySelector('#maiwe-header')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }

      const isMobileLayout = window.matchMedia('(max-width: 991px)').matches;
      const mobile = document.querySelector('maiwe-mobile-menu');
      const desktop = document.querySelector('maiwe-header-menu');

      if (isMobileLayout && mobile && typeof mobile.openMenuByKey === 'function') {
        return Boolean(mobile.openMenuByKey(key));
      }

      if (!isMobileLayout && desktop && typeof desktop.openMenuByKey === 'function') {
        return Boolean(desktop.openMenuByKey(key));
      }

      if (desktop && typeof desktop.openMenuByKey === 'function' && desktop.openMenuByKey(key)) {
        return true;
      }

      if (mobile && typeof mobile.openMenuByKey === 'function' && mobile.openMenuByKey(key)) {
        return true;
      }

      return false;
    }

    window.maiweOpenMenuByKey = maiweOpenMenuByKey;

    function applyMaiweMenuDeepLink() {
      const key = menuKeyFromHash();
      if (!key) return;

      const opened = maiweOpenMenuByKey(key);

      if (opened) {
        const isMobileLayout = window.matchMedia('(max-width: 991px)').matches;
        const mobile = document.querySelector('maiwe-mobile-menu');
        const desktop = document.querySelector('maiwe-header-menu');

        // Strip the hash only when the menu is closed, not immediately on open.
        if (isMobileLayout && mobile) {
          waitForMobileMenuClose(mobile);
        } else if (!isMobileLayout && desktop) {
          waitForDesktopMenuClose(desktop);
        }
      }
    }

    /**
     * Removes the deep-link hash once the mobile menu drawer is closed.
     * Listens for: close button click, Escape key, or the drawer losing its is-open class.
     * @param {HTMLElement} mobile
     */
    function waitForMobileMenuClose(mobile) {
      function onClose() {
        stripMenuDeepLinkHash();
        cleanup();
      }

      function cleanup() {
        mobile.removeEventListener('maiwe:menu-closed', onClose);
        document.removeEventListener('keydown', onEscape);
        for (const btn of mobile.querySelectorAll('[data-mobile-menu-close]')) {
          btn.removeEventListener('click', onClose);
        }
      }

      function onEscape(e) {
        if (e.key === 'Escape') onClose();
      }

      // Close buttons inside the mobile drawer
      for (const btn of mobile.querySelectorAll('[data-mobile-menu-close]')) {
        btn.addEventListener('click', onClose, { once: true });
      }
      document.addEventListener('keydown', onEscape);

      // MutationObserver as a fallback: watch for is-open being removed
      const observer = new MutationObserver(() => {
        if (!mobile.classList.contains('is-open')) {
          observer.disconnect();
          onClose();
        }
      });
      observer.observe(mobile, { attributes: true, attributeFilter: ['class'] });
    }

    /**
     * Removes the deep-link hash once the desktop mega menu is closed.
     * Listens for: clicking outside the menu or pressing Escape.
     * @param {HTMLElement} desktop
     */
    function waitForDesktopMenuClose(desktop) {
      function onClose() {
        stripMenuDeepLinkHash();
        cleanup();
      }

      function cleanup() {
        document.removeEventListener('click', onOutsideClick);
        document.removeEventListener('keydown', onEscape);
        observer.disconnect();
      }

      function onOutsideClick(e) {
        if (!(e.target instanceof Node)) return;
        if (!desktop.contains(e.target)) onClose();
      }

      function onEscape(e) {
        if (e.key === 'Escape') onClose();
      }

      document.addEventListener('click', onOutsideClick);
      document.addEventListener('keydown', onEscape);

      // MutationObserver as a fallback: watch for all submenus closing (aria-expanded gone)
      const observer = new MutationObserver(() => {
        const anyOpen = desktop.querySelector('[data-submenu-trigger="top"][aria-expanded="true"]');
        if (!anyOpen) {
          observer.disconnect();
          onClose();
        }
      });
      observer.observe(desktop, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
    }

    /**
     * Initializes cross-hover highlighting between product images and their titles in the submenus.
     */
    function initMegaMenuCrossHover() {
      const desktopMenu = document.querySelector('maiwe-header-menu');
      if (!desktopMenu) return;

      desktopMenu.addEventListener('mouseover', (e) => {
        const target = e.target.closest('[data-product-handle]');
        if (!target) return;

        const handle = target.getAttribute('data-product-handle');
        if (!handle) return;

        const matchingElements = desktopMenu.querySelectorAll(`[data-product-handle="${handle}"]`);
        matchingElements.forEach((el) => {
          el.classList.add('is-hovered');
        });
      });

      desktopMenu.addEventListener('mouseout', (e) => {
        const target = e.target.closest('[data-product-handle]');
        if (!target) return;

        const handle = target.getAttribute('data-product-handle');
        if (!handle) return;

        const matchingElements = desktopMenu.querySelectorAll(`[data-product-handle="${handle}"]`);
        matchingElements.forEach((el) => {
          el.classList.remove('is-hovered');
        });
      });
    }

    window.addEventListener('hashchange', applyMaiweMenuDeepLink);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        applyMaiweMenuDeepLink();
        initMegaMenuCrossHover();
      });
    } else {
      applyMaiweMenuDeepLink();
      initMegaMenuCrossHover();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-promo-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__maiweFloatingPromoBound) return;
    window.__maiweFloatingPromoBound = true;

    const QUIZ_MENU_KEYS = ['skinquiz', 'skin-quiz'];

    /**
     * Avada FAQ loads async; retry before giving up.
     * @param {number} attempt
     */
    function tryOpenAvadaChat(attempt) {
      const candidates = [
        document.getElementById('Avada-FAQ_WidgetTrigger'),
        document.getElementById('avada-faq_widgettrigger'),
        document.querySelector('[id="Avada-FAQ_WidgetTrigger"]'),
        document.querySelector('button[id*="Avada-FAQ"][id*="WidgetTrigger"]'),
        document.querySelector('[id*="Avada-FAQ"][id*="WidgetTrigger"]'),
      ];

      for (const el of candidates) {
        if (el instanceof HTMLElement) {
          el.click();
          return;
        }
      }

      if (attempt < 20) {
        window.setTimeout(() => tryOpenAvadaChat(attempt + 1), 120);
      }
    }

    function openSkinQuizNav() {
      const openMenu =
        typeof window.maiweOpenMenuByKey === 'function'
          ? window.maiweOpenMenuByKey.bind(window)
          : null;

      for (const key of QUIZ_MENU_KEYS) {
        if (openMenu && openMenu(key)) {
          return;
        }
      }

      const isMobileLayout = window.matchMedia('(max-width: 991px)').matches;
      const mobile = document.querySelector('maiwe-mobile-menu');
      const desktop = document.querySelector('maiwe-header-menu');

      for (const key of QUIZ_MENU_KEYS) {
        if (isMobileLayout && mobile && typeof mobile.openMenuByKey === 'function' && mobile.openMenuByKey(key)) {
          document.querySelector('#maiwe-header')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
          return;
        }
        if (!isMobileLayout && desktop && typeof desktop.openMenuByKey === 'function' && desktop.openMenuByKey(key)) {
          document.querySelector('#maiwe-header')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
          return;
        }
      }

      const key = QUIZ_MENU_KEYS[0];
      const targetHash = `#maiwe-menu-${key}`;
      if (window.location.hash !== targetHash) {
        window.location.hash = targetHash;
      } else {
        window.dispatchEvent(new HashChangeEvent('hashchange'));
      }
    }

    document.addEventListener(
      'click',
      (event) => {
        const control = event.target.closest('[data-floating-promo-control]');
        if (!(control instanceof HTMLElement)) return;

        const root = control.closest('[data-floating-promo-root]');
        if (!(root instanceof HTMLElement)) return;

        const action = root.dataset.action;
        if (!action || action === 'link') return;

        event.preventDefault();
        event.stopPropagation();

        if (action === 'chat') {
          tryOpenAvadaChat(0);
          return;
        }

        if (action === 'quiz') {
          window.requestAnimationFrame(() => {
            openSkinQuizNav();
          });
        }
      },
      false
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-hotspots"] && !Shopify.designMode) return;
  try {
    
  class JourneyHotspots extends HTMLElement {
    connectedCallback() {
      this.badges = [...this.querySelectorAll('.journey-hotspots__badge')];
      this.panels = [...this.querySelectorAll('.journey-hotspots__detail-panel')];
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      if (window.Shopify?.designMode) {
        console.debug('[journey-hotspots]', {
          badges: this.badges.length,
          panels: this.panels.length,
          panelIds: this.panels.map((panel) => panel.id),
          badgeControls: this.badges.map((badge) => badge.getAttribute('aria-controls')),
          blocksSize: this.dataset.debugBlocksSize,
          blockTypes: this.dataset.debugBlockTypes,
        });
      }

      for (const badge of this.badges) {
        badge.addEventListener('mouseenter', this.#handleBadgeHover);
        badge.addEventListener('focus', this.#handleBadgeFocus);
        badge.addEventListener('click', this.#handleBadgeClick);
      }

      this.addEventListener('click', this.#handleCloseClick);
    }

    disconnectedCallback() {
      for (const badge of this.badges || []) {
        badge.removeEventListener('mouseenter', this.#handleBadgeHover);
        badge.removeEventListener('focus', this.#handleBadgeFocus);
        badge.removeEventListener('click', this.#handleBadgeClick);
      }

      this.removeEventListener('click', this.#handleCloseClick);
    }

    #handleBadgeHover = (event) => {
      if (!this.desktopQuery.matches) return;
      this.#activateFromBadge(event.currentTarget);
    };

    #handleBadgeFocus = (event) => {
      this.#activateFromBadge(event.currentTarget);
    };

    #handleBadgeClick = (event) => {
      this.#activateFromBadge(event.currentTarget);
    };

    #handleCloseClick = (event) => {
      const closeButton = event.target.closest('.journey-hotspots__detail-panel-close');
      if (!(closeButton instanceof HTMLElement)) return;

      event.preventDefault();
      this.#closeActivePanel();
    };

    #activateFromBadge(target) {
      if (!(target instanceof HTMLElement)) return;

      const badge = target.classList.contains('journey-hotspots__badge')
        ? target
        : target.querySelector('.journey-hotspots__badge');

      const panelId = badge?.getAttribute('aria-controls');
      if (panelId) {
        this.#setActiveByPanelId(panelId);
      }
    }

    #setActiveByPanelId(panelId) {
      const activePanel = this.ownerDocument.getElementById(panelId);
      if (!(activePanel instanceof HTMLElement)) return;

      for (const badge of this.badges) {
        const selected = badge.getAttribute('aria-controls') === panelId;
        badge.setAttribute('aria-expanded', selected ? 'true' : 'false');
      }

      for (const panel of this.panels) {
        const selected = panel.id === panelId;
        panel.classList.toggle('is-active', selected);
      }
    }

    #closeActivePanel() {
      for (const badge of this.badges) {
        badge.setAttribute('aria-expanded', 'false');
      }

      for (const panel of this.panels) {
        panel.classList.remove('is-active');
      }
    }
  }

  if (!customElements.get('journey-hotspots')) {
    customElements.define('journey-hotspots', JourneyHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-sequence-carousel"] && !Shopify.designMode) return;
  try {
    
  class StepSequenceCarousel extends HTMLElement {
    /** @type {number | undefined} */
    #advanceTimer;

    /** @type {(() => void) | undefined} */
    #removeVideoEndedListener;

    /** @type {AbortController | undefined} */
    #abortHover;

    /** @type {MediaQueryList | undefined} */
    #navTabMql;

    /** @type {IntersectionObserver | undefined} */
    #observer;

    connectedCallback() {
      this.addEventListener('slideshow:select', this.#handleSlideSelect);

      this.#navTabMql = window.matchMedia('(max-width: 749px)');
      this.#navTabMql.addEventListener('change', this.#syncNavTabOrder);

      const slideshow = this.querySelector('slideshow-component');
      if (!(slideshow instanceof HTMLElement)) {
        requestAnimationFrame(() => this.#syncNavTabOrder());
        return;
      }

      slideshow.removeAttribute('autoplay');

      if (this.dataset.autoplay === 'true') {
        this.#abortHover = new AbortController();
        const { signal } = this.#abortHover;
        slideshow.addEventListener('mouseenter', this.#suspendAdvance, { signal });
        slideshow.addEventListener('mouseleave', this.#resumeAdvance, { signal });
        document.addEventListener('visibilitychange', this.#handleVisibilityChange, { signal });
      }

      requestAnimationFrame(() => {
        this.#syncPlayback(undefined);
        this.#syncNavTabOrder();
      });

      // Pause/resume autoplay as the section enters/leaves the viewport
      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (this.dataset.autoplay === 'true') {
                const activeSlide = slideshow.querySelector('slideshow-slide[aria-hidden="false"]');
                if (activeSlide instanceof HTMLElement) {
                  this.#scheduleAdvanceForSlide(activeSlide);
                }
              }
            } else {
              this.#clearAdvanceSchedule();
            }
          }
        },
        { threshold: 0.25 }
      );
      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.removeEventListener('slideshow:select', this.#handleSlideSelect);
      this.#navTabMql?.removeEventListener('change', this.#syncNavTabOrder);
      this.#abortHover?.abort();
      this.#clearAdvanceSchedule();
      this.#observer?.disconnect();
      this.#observer = undefined;
    }

    #syncNavTabOrder = () => {
      const nav = this.querySelector('.step-sequence-carousel__nav');
      if (!nav) return;

      const narrow =
        this.#navTabMql?.matches ?? window.matchMedia('(max-width: 749px)').matches;
      for (const btn of nav.querySelectorAll('button.step-sequence-carousel__nav-button')) {
        if (!(btn instanceof HTMLButtonElement)) continue;
        const selected = btn.getAttribute('aria-selected') === 'true';
        btn.tabIndex = narrow && !selected ? -1 : 0;
      }
    };

    #handleSlideSelect = (event) => {
      const slide = event.detail?.slide;
      this.#syncPlayback(slide instanceof HTMLElement ? slide : undefined);
      this.#syncNavTabOrder();

      if (this.dataset.autoplay === 'true' && slide instanceof HTMLElement) {
        this.#scheduleAdvanceForSlide(slide);
      }
    };

    /**
     * @param {HTMLElement | undefined} activeSlide
     */
    #syncPlayback(activeSlide) {
      const slideshow = this.querySelector('slideshow-component');
      const slides = slideshow?.querySelectorAll('slideshow-slide');

      if (!slides?.length) return;

      for (const slide of slides) {
        if (!(slide instanceof HTMLElement)) continue;

        const video = slide.querySelector('video');
        const isActive = activeSlide ? slide === activeSlide : slide.getAttribute('aria-hidden') === 'false';

        if (!(video instanceof HTMLVideoElement)) continue;

        if (!isActive) {
          video.pause();
          continue;
        }

        if (video.readyState > 0) {
          video.currentTime = 0;
        }

        const playPromise = video.play();
        playPromise?.catch(() => {});
      }
    }

    #suspendAdvance = () => {
      this.#clearAdvanceSchedule();
    };

    #resumeAdvance = () => {
      if (this.dataset.autoplay !== 'true') return;
      if (document.hidden) return;

      const slideshow = this.querySelector('slideshow-component');
      const slide = slideshow?.querySelector('slideshow-slide[aria-hidden="false"]');
      if (slide instanceof HTMLElement) {
        this.#scheduleAdvanceForSlide(slide);
      }
    };

    #handleVisibilityChange = () => {
      if (document.hidden) {
        this.#clearAdvanceSchedule();
      } else {
        this.#resumeAdvance();
      }
    };

    #clearAdvanceSchedule() {
      clearTimeout(this.#advanceTimer);
      this.#advanceTimer = undefined;

      if (this.#removeVideoEndedListener) {
        this.#removeVideoEndedListener();
        this.#removeVideoEndedListener = undefined;
      }
    }

    /**
     * @param {HTMLElement} slide
     */
    #scheduleAdvanceForSlide(slide) {
      this.#clearAdvanceSchedule();

      if (this.dataset.autoplay !== 'true') return;

      const slideshow = this.querySelector('slideshow-component');
      if (!(slideshow instanceof HTMLElement)) return;

      const speedSec = parseInt(this.dataset.autoplaySpeed || '5', 10);
      const speedMs = Number.isFinite(speedSec) ? Math.max(speedSec, 1) * 1000 : 5000;
      const videoLoops = this.dataset.videoLoop === 'true';

      const video = slide.querySelector('.step-sequence-carousel__video');

      if (video instanceof HTMLVideoElement && !videoLoops) {
        let didAdvance = false;
        const advanceOnce = () => {
          if (didAdvance) return;
          didAdvance = true;
          this.#clearAdvanceSchedule();
          slideshow.next?.();
        };

        const onEnded = () => advanceOnce();

        const onTimeUpdate = () => {
          const duration = video.duration;
          if (Number.isFinite(duration) && duration > 0 && video.currentTime >= duration - 0.35) {
            video.removeEventListener('timeupdate', onTimeUpdate);
            advanceOnce();
          }
        };

        video.addEventListener('ended', onEnded, { once: true });
        video.addEventListener('timeupdate', onTimeUpdate);

        this.#removeVideoEndedListener = () => {
          video.removeEventListener('ended', onEnded);
          video.removeEventListener('timeupdate', onTimeUpdate);
        };

        return;
      }

      if (slideshow.matches(':hover') || document.hidden) return;

      this.#advanceTimer = window.setTimeout(() => {
        slideshow.next?.();
      }, speedMs);
    }
  }

  if (!customElements.get('step-sequence-carousel')) {
    customElements.define('step-sequence-carousel', StepSequenceCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
